export const StatusOptionEnum = {
  OPEN: 'O',
  CLOSED: 'C',
};
export const StatusEnum = {
  All: 'All',
  Open: 'Open',
  Closed: 'Closed',
};

export const PrintOptionsEnum = {
  ItemCode: 'ItemCode',
  ItemDescription: 'ItemDescription',
};

export const NewEditUsageEnum = {
  NEW: '0',
  EDIT: '1',
};
export const SiteStatusEnum = {
  EMPTY: '0',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/UsageListEnum.js